module.exports = __webpack_public_path__ + "img/jwcy2.335101c7.png";